import i18n from "@Shared/@i18n";
export const InterestTypeE = {
  Fixed: 0,
  Adjustable: 1,
  "Capped Variable": 2,
  Variable: 3,
  Buydown: 4
};
export const TermTypeE = {
  Closed: 0,
  Open: 1,
  Convertible: 2
};
export const MortgageInsurerE = {
  CMHC: 1,
  Genworth: 2,
  "Canada Guaranty": 3
};
export const PaymentFrequencyE = {
  Monthly: 0,
  "Semi Monthly": 1,
  Biweekly: 2,
  "Accelerated Biweekly": 3,
  Weekly: 4,
  "Accelerated Weekly": 5
};
export const DealTypeE = {
  approval: 0,
  "pre-approval": 1
};
export const DealPurposeE = {
  "purchase-approval": 0,
  "purchase-improvements": 1,
  "refinance-approval": 2,
  eto: 3,
  "switch-transfer": 4,
  port: 5,
  "deficiency-sale": 6,
  workout: 7
};
export const MortgageTypeE = {
  first: 1,
  second: 2,
  third: 3
};
export var ACCOUNT_PLAN_PAGE;
(function (ACCOUNT_PLAN_PAGE) {
  ACCOUNT_PLAN_PAGE["BOARD_LEVEL_AUTOMATION"] = "board-automation";
  ACCOUNT_PLAN_PAGE["APPLICATION_LEVEL_AUTOMATION"] = "application-automation";
  ACCOUNT_PLAN_PAGE["E_SIGN"] = "e-sign";
  ACCOUNT_PLAN_PAGE["NOA"] = "noa";
  ACCOUNT_PLAN_PAGE["BANK_STATEMENT"] = "bank-statement";
  ACCOUNT_PLAN_PAGE["DRIP_CAMPAIGN"] = "drip-campaign";
  ACCOUNT_PLAN_PAGE["MARKETING_CAMPAIGN"] = "remarketing-campaign";
  ACCOUNT_PLAN_PAGE["DOCUMENT_REQUEST_RULE"] = "document-request-rule";
})(ACCOUNT_PLAN_PAGE || (ACCOUNT_PLAN_PAGE = {}));
export const PERSONAL_SETTINGS_TABS = () => [{
  key: "account",
  label: i18n.t("settings.tabs.account").toString(),
  children: [{
    label: i18n.t("settings.accountTab.tabs.profile").toString(),
    key: "profile"
  }, {
    label: i18n.t("settings.accountTab.tabs.personalDetails").toString(),
    key: "personal-details"
  }, {
    label: i18n.t("settings.accountTab.tabs.emailPreferences").toString(),
    key: "email-preferences"
  }, {
    label: i18n.t("settings.accountTab.tabs.lenderSubmissionDetails").toString(),
    key: "filogix-details"
  }, {
    label: i18n.t("settings.accountTab.tabs.applicationRecurringReminders").toString(),
    key: "recurring-reminders"
  }]
}, {
  key: "notifications",
  label: i18n.t("settings.tabs.notifications").toString()
}, {
  key: "theme",
  label: i18n.t("settings.tabs.theme").toString()
}, {
  key: "application-form",
  label: i18n.t("settings.tabs.applicationForm").toString()
}, {
  key: "disclaimers",
  label: i18n.t("settings.tabs.disclaimers").toString()
}, {
  key: "faq",
  label: i18n.t("settings.tabs.FAQ").toString()
}];
export const BROKERAGE_SETTINGS_TABS = () => [{
  key: "brokerage",
  label: i18n.t("settings.tabs.brokerage").toString()
}, {
  key: "theme",
  label: i18n.t("settings.tabs.theme").toString()
}, {
  key: "application-form",
  label: i18n.t("settings.tabs.applicationForm").toString()
}, {
  key: "disclaimers",
  label: i18n.t("settings.tabs.disclaimers").toString()
}, {
  key: "faq",
  label: i18n.t("settings.tabs.FAQ").toString()
}, {
  key: "boards",
  label: i18n.t("settings.tabs.boards").toString()
}, {
  key: "co-brokering",
  label: i18n.t("settings.tabs.co-brokering").toString()
}];
export const ACCOUNT_PLAN_TABS = () => ({
  "current-account": {
    label: i18n.t("account.accountPlan.tabs.yourAccountPlan").toString(),
    component: "current-account-container",
    routeName: "account-plan-tab",
    params: {
      internal: true
    }
  },
  subscriptions: {
    label: i18n.t("account.accountPlan.tabs.subscriptions").toString(),
    component: "subscriptions-container",
    routeName: "account-plan-tab",
    params: {
      internal: true
    }
  },
  "payment-methods": {
    label: i18n.t("account.accountPlan.tabs.paymentMethods").toString(),
    component: "payment-methods",
    routeName: "account-plan-tab",
    params: {
      internal: true
    }
  },
  invoices: {
    label: i18n.t("account.accountPlan.tabs.invoices").toString(),
    component: "invoices-container",
    routeName: "account-plan-tab",
    params: {
      internal: true
    }
  }
});